import { initMenu } from "./js/menu.js";
import { initScroll } from "./js/scroll.js";
import { initCard3d } from "./js/card-3d.js";
import { loadFaq } from "./js/faq-content.js";
import { loadTestimonials } from "./js/testimonials-content.js";

initMenu();
initScroll();
initCard3d();
loadFaq();
loadTestimonials();
